import { compareAsc, isWithinInterval } from 'date-fns';
import { Account, AnalysisBounds, DailyBalance } from '@algoan/dashboard/model';
import { parseDailyBalanceDate } from './date';

/**
 * Compare two daily balances, to be used in a sort function
 */
const compareDailyBalancesAscending = (dailyBalanceA: DailyBalance, dailyBalanceB: DailyBalance): number => {
  if (dailyBalanceA.date === dailyBalanceB.date) {
    return 0;
  }

  return compareAsc(new Date(dailyBalanceA.date), new Date(dailyBalanceB.date));
};

export const sumDailyBalancesFromAccounts = (accounts: Account[]): DailyBalance[] => {
  if (accounts.length === 0) {
    return [];
  } else if (accounts.length === 1) {
    return accounts[0].dailyBalances;
  }

  return accounts
    .slice(1)
    .reduce<DailyBalance[]>(
      (sumOfDailyBalances, account) => {
        account.dailyBalances.forEach((dailyBalance) => {
          const existingDailyBalance = sumOfDailyBalances.find((balance) => balance.date === dailyBalance.date);

          if (!existingDailyBalance) {
            sumOfDailyBalances.push({ ...dailyBalance });

            return;
          }

          existingDailyBalance.balance += dailyBalance.balance;
        });

        return sumOfDailyBalances;
      },
      accounts[0].dailyBalances.map((dailyBalance) => ({ ...dailyBalance })),
    )
    .sort(compareDailyBalancesAscending);
};

export const filterDailyBalancesOnAnalysisBounds = (
  dailyBalances: DailyBalance[],
  analysisBounds?: AnalysisBounds,
): DailyBalance[] => {
  if (!analysisBounds) {
    return dailyBalances;
  }

  const [start, end] = analysisBounds;
  return dailyBalances.filter((dailyBalance) =>
    isWithinInterval(parseDailyBalanceDate(dailyBalance.date), { start, end }),
  );
};
